import React, { FC } from 'react';
import { graphql, HeadFC, PageProps } from 'gatsby';
import { PageContext } from '../../gatsby-node';

import Home from '../views/Home';
import Layout from '../components/Layout';
import SEO from '../components/Head';

const Page: FC<PageProps<Queries.MercuryoPageQuery, PageContext>> = props => {
  const {
    data,
    pageContext: { locale },
  } = props;

  return (
    <Layout>
      <Home data={data} locale={locale} provider="mercuryo" />
    </Layout>
  );
};

export const Head: HeadFC<Queries.MercuryoPageQuery, PageContext> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query MercuryoPage($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/mercuryo/**" }) {
      childJson {
        ...Meta
        ...SeoNavbar
        ...SeoHeaderHome
        ...SeoWhyHome
        ...SeoGuide
        ...SeoReadytoGetStarted
        ...SeoFooter
      }
    }
  }
`;

export default Page;
